import { apiClientPbx } from '@/api/sipmovil_auth_api.js'

export default {
  getBySender(senderId) {
    return apiClientPbx.get(`api/chat/reminders/sender/${senderId}/`)
  },
  create(data) {
    return apiClientPbx.post('api/chat/reminders/', data)
  },
  update(reminderId, data) {
    return apiClientPbx.put(`api/chat/reminders/${reminderId}/`, data)
  },
  remove(reminderId) {
    return apiClientPbx.delete(`api/chat/reminders/${reminderId}/delete/`)
  },
}
